import { cn } from '../../lib/utils';

const sizes = {
  sm: 'h-4 w-4 border-2',
  default: 'h-6 w-6 border-2',
  lg: 'h-9 w-9 border-[3px]',
} as const;

/** Indeterminate loading spinner. Inherits `text-*` color (defaults to brand). */
export function Spinner({
  size = 'default',
  className,
  label = 'Loading',
}: {
  size?: keyof typeof sizes;
  className?: string;
  label?: string;
}) {
  return (
    <span
      role="status"
      aria-label={label}
      className={cn(
        'inline-block animate-spin rounded-full border-current border-t-transparent text-iris',
        sizes[size],
        className,
      )}
    />
  );
}
